import { put, call, fork, takeEvery, all, select } from 'redux-saga/effects';

import * as dashboardModule from '../modules/dashboard.module';
import * as Api from '../../core/api';

export function* fetchPerformance({ payload }) {
  const { response, error } = yield call(Api.dashboard.fetchPerformance, payload);

  if (response) {
    yield put(dashboardModule.fetchPerformanceSuccess({ data: response, ...payload }));
  } else {
    yield put(dashboardModule.fetchPerformanceFail(error));
  }
}
export function* watchFetchPerformance() {
  yield takeEvery(dashboardModule.fetchPerformance.getType(), fetchPerformance);
}

export function* fetchTablePerformance({ payload }) {
  const dashboard = yield select(state => state.dashboard);
  const { response, error } = yield call(Api.dashboard.fetchTablePerformance, {
    ...payload,
    filter: {
      ...payload.filter,
      ...dashboard.table.filter,
    },
  });

  if (response) {
    yield put(dashboardModule.fetchTablePerformanceSuccess({ data: response, ...payload }));
  } else {
    yield put(dashboardModule.fetchTablePerformanceFail(error));
  }
}
export function* watchFetchTablePerformance() {
  yield takeEvery(dashboardModule.fetchTablePerformance.getType(), fetchTablePerformance);
}

export function* filterTablePerformance({ payload }) {
  const dashboard = yield select(state => state.dashboard);
  const obj = {
    period: dashboard.period,
    sort: dashboard.table.sort,
    filter: {
      ...dashboard.filter,
      ...payload.filter,
    },
    page: payload.page,
    itemsPerPage: payload.itemsPerPage,
  };
  const { response, error } = yield call(Api.dashboard.fetchTablePerformance, obj);

  if (response) {
    yield put(dashboardModule.fetchTablePerformanceSuccess({ data: response, ...obj }));
  } else {
    yield put(dashboardModule.fetchTablePerformanceFail(error));
  }
}
export function* watchFilterTablePerformance() {
  yield takeEvery(dashboardModule.filterTablePerformance.getType(), filterTablePerformance);
}

export function* fetchApps() {
  const { response, error } = yield call(Api.dashboard.fetchApps);

  if (response) {
    yield put(dashboardModule.fetchAppsSuccess({ apps: response }));
  } else {
    yield put(dashboardModule.fetchAppsFail(error));
  }
}

export function* fetchFiltersData() {
  const { response, error } = yield call(Api.dashboard.fetchFiltersData);
  if (response) {
    yield put(dashboardModule.fetchFiltersDataSuccess(response));
  } else {
    yield put(dashboardModule.fetchFiltersDataFail(error));
  }
}

export function* watchFetchFiltersData() {
  yield takeEvery(dashboardModule.fetchFiltersData.getType(), fetchFiltersData);
}

export function* fetchInsights({ payload }) {
  const { response, error } = yield call(Api.dashboard.fetchInsights, payload);

  if (response) {
    yield put(dashboardModule.fetchInsightsSuccess({
      data: response, period: payload.period, filter: payload.filter,
    }));
  } else {
    yield put(dashboardModule.fetchInsightsFail(error));
  }
}
export function* watchFetchInsights() {
  yield takeEvery(dashboardModule.fetchInsights.getType(), fetchInsights);
}

export default function* watchDashboard() {
  return yield all([
    fork(watchFetchPerformance),
    fork(watchFetchTablePerformance),
    fork(watchFilterTablePerformance),
    fork(watchFetchFiltersData),
    fork(watchFetchInsights),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/dashboard.saga.js
 **/